// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Supplier-List-__List___ioT8z","table-header":"app-pages-Inventory-Supplier-List-__List___kissr","table-content-wrapper":"app-pages-Inventory-Supplier-List-__List___3IwnC","table-content":"app-pages-Inventory-Supplier-List-__List___onY2t","selected":"app-pages-Inventory-Supplier-List-__List___1Dmfb"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/Supplier/List/List.css
// module id = 2391
// module chunks = 0